function searchComponent() {
  return {
    query: '',
    page: 1,
    products: [],
    pages: [],
    recipes: [],
    collections: [],
    totalPages: 0,
    totalRecipePages: 0,
    itemsPerPage: 36,
    showPagination: true,
    totalProductHits: 0,
    totalRecipeHits: 0,
    excludedHandles: [
      'bundle',
      'bundle-dummy',
      'gratisbuch',
      'dein-gratisprodukt',
      'dein-gratistee',
      'reisekraut',
      // 'cube-adventskalender',
      'best-of-adventskalender',
      // 'premium-adventskalender',
      // 'luette-adventskalender',
      // 'deluxe-adventskalender',
      // 'das-beste-adventskalender-kollektion',
      // 'mega-adventskalender-kollektion',
    ],
    facetDistribution: {product: {tags: {}}, recipe: {tags: {}}},
    selectedFacets: [],
    selectedFacetCategories: {
      sort: ['Relevanz'],
      geeignet_zum: [],
      passt_zu: [],
      ernaehrung: [],
      landestypisch: [],
      ernaehrungsweise: [],
      art: [],
      herkunft: [],
      zubereitungsweise: [],
    },
    availableFacetCategories: {
      product: {
        sort: {
          label: 'Sortieren nach',
          alt_label: 'Sortieren nach',
          values: [
            {
              label: 'Relevanz',
              value: '[monthly_sales:desc]',
            },
            {
              label: 'Beste Bewertung',
              value: '[rating:desc]',
            },
            {
              label: 'Neuheiten zuerst',
              value: '[created_at:desc]',
            },
            {
              label: 'Name A-Z',
              value: '[title:asc]',
            },
            {
              label: 'Name Z-A',
              value: '[title:desc]',
            },
            {
              label: 'Preis absteigend',
              value: '[price:desc]',
            },
            {
              label: 'Preis aufsteigend',
              value: '[price:asc]',
            },
          ],
        },
        geeignet_zum: {
          label: 'Geeignet zum_',
          alt_label: 'Geeignet zum',
          values: ['Kochen', 'Backen', 'Grillen', 'Rubs & Finisher', 'Dippen'],
        },
        passt_zu: {
          label: 'Passt zu_',
          alt_label: 'Passt zu',
          values: [
            'Rind',
            'Schwein',
            'Geflügel',
            'Wild',
            'Fisch / Meeresfrüchte',
            'Lamm',
            'Tofu',
            'Käse / Milch- u. Eierprodukte',
            'Gemüse',
            'Obst',
            'Pasta',
            'Reis',
            'Kartoffel',
            'Salat',
            'Suppe / Eintöpfe',
            'Sauce',
            'Brot',
            'Gebäck',
          ],
        },
        ernaehrung: {
          label: 'Ernährung_',
          alt_label: 'Ernährung',
          values: ['Bio', 'Vegan', 'Vegetarisch'],
        },
        // could be "landestypisch_für" and then in alpine loop through the object and replace the label into the key
        landestypisch: {
          label: 'Landestypisch für_',
          alt_label: 'Länderküche',
          values: ['Deutschland', 'Spanien', 'Italien', 'Indien', 'Mexiko', 'Griechenland', 'Türkei', 'China', 'Thailand', 'Marokko'],
        },
      },
      recipe: {
        sort: {
          label: 'Sortieren nach',
          alt_label: 'Sortieren nach',
          values: [
            {
              label: 'Relevanz',
              value: '[monthly_sales:desc]',
            },
            {
              label: 'Beste Bewertung',
              value: '[rating:desc]',
            },
            {
              label: 'Neuheiten zuerst',
              value: '[created_at:desc]',
            },
            {
              label: 'Name A-Z',
              value: '[title:asc]',
            },
            {
              label: 'Name Z-A',
              value: '[title:desc]',
            },
            {
              label: 'Gesamtaufwand absteigend',
              value: '[total_time:desc]',
            },
            {
              label: 'Gesamtaufwand aufsteigend',
              value: '[total_time:asc]',
            },
          ],
        },
        ernaehrungsweise: {
          label: 'Ernährungsweise',
          alt_label: 'Ernährungsweise',
          values: ['Fleisch', 'Günstig', 'lowcarb', 'Pescetarisch', 'Vegan', 'Vegetarisch'],
        },
        art: {
          label: 'Art',
          alt_label: 'Art',
          values: ['Curry', 'Kartoffeln', 'Pasta', 'Reis', 'Salat', 'Snack', 'Suppe 🥣', 'Weihnachten', 'Frühstück'],
        },
        herkunft: {
          label: 'Herkunft',
          alt_label: 'Herkunft',
          values: [
            'Asiatisch',
            'Amerikanisch',
            'Arabisch',
            'Afrikanisch',
            'Orientalisch',
            'Deutsch',
            'Spanisch',
            'Italienisch',
            'Indisch',
            'Mexikanisch',
            'Griechisch',
            'Türkisch',
            'Chinesisch',
            'Marokkanisch',
            'Französisch',
            'Japanisch',
          ],
        },
        zubereitungsweise: {
          label: 'Zubereitungsweise',
          alt_label: 'Zubereitungsweise',
          values: ['Kochen', 'Backen', 'Grillen', 'Braten', 'Heißluftfritteuse'],
        },
      },
    },
    type: 'product',
    filterType: 'all',
    width: window.innerWidth,
    // headerOffset: 0,
    sort: '[monthly_sales:desc]',
    open: false,
    filterPanelOpen: false,
    debounceTimer: 0,
    minQueryLength: !Alpine.store('meiliNewProductsVisible').enabled ? 3 : 0,

    get combined() {
      const combinedArray = [...this.pages.map((page) => ({...page, type: 'page'})), ...this.recipes.map((recipe) => ({...recipe, type: 'recipe'}))]
      return combinedArray
    },

    async search(initOrNextPage = false) {
      if (this.query.length < this.minQueryLength && !Alpine.store('meiliNewProductsVisible').enabled) return
      if (this.sort === '[monthly_sales:desc]') {
        this.resetSorting()
      }
      if (this.query.length >= this.minQueryLength && this.query.length != 0 && this.sort === '[monthly_sales:desc]') {
        this.sort = ''
      }
      const meilisearchElement = document.querySelector('.meilisearch')

      let url = `https://suche.ankerkraut.de/search?q=${encodeURIComponent(this.query)}&page=${this.page}`

      if ((this.type === 'product' || this.type === 'recipe') && this.selectedFacets.length > 0) {
        url += `&facets=${this.selectedFacets}`
      }
      if ((this.type === 'product' || this.type === 'recipe') && this.sort) {
        url += `&sort=${this.sort}`
      }
      try {
        const response = await fetch(url).then((res) => res.json())
        if (this.type === 'product') {
          this.products = this.filterProducts(response.products || [])
          this.pages = []
          this.recipes = []
        } else if (this.type === 'recipe') {
          this.recipes = (response.recipes || []).filter((recipe) => recipe.blog_handle === 'rezepte')
          this.pages = []
          this.products = []
        } else if (this.type === 'page') {
          this.pages = (response.pages || []).concat((response.recipes || []).filter((recipe) => recipe.blog_handle === 'magazin'))
          this.recipes = []
          this.products = []
        }

        this.collections = response.collections || []
        this.totalProductHits = response.total_product_hits || 0
        this.totalRecipeHits = this.recipes.length || 0
        this.totalPages = Math.ceil(response.total_product_hits / response.hits_per_page)
        this.totalRecipePages = Math.ceil(response.total_recipe_hits / response.hits_per_page)
        this.facetDistribution = response.facet_distribution || []

        if (this.type !== 'product' && this.type !== 'recipe') {
          this.selectedFacets = []
          this.priceMin = 0
          this.priceMax = 10
        }
        if (this.products.length || this.pages.length || this.recipes.length || this.collections.length) {
          if (!initOrNextPage) {
            meilisearchElement.classList.add('has-results')
          }
        } else {
          meilisearchElement.classList.remove('has-results')
        }
        Alpine.nextTick(() => {})
      } catch (error) {
        console.error('Error fetching search results:', error)
        meilisearchElement.classList.remove('has-results')
      }
      this.debounceTimer = 0
    },

    stripHtmlAndTruncate(html, maxLength) {
      const div = document.createElement('div')
      div.innerHTML = html
      let text = div.textContent || div.innerText || ''
      if (maxLength && text.length > maxLength) {
        return text.substring(0, maxLength) + '...'
      }
      return text
    },

    /**
     * Safely parses recipekit data from object or JSON string input.
     */
    parseRecipekit(recipekit) {
      let recipeData = recipekit

      if (typeof recipeData === 'string') {
        try {
          recipeData = JSON.parse(recipeData)
        } catch (error) {
          return {}
        }
      }

      if (typeof recipeData === 'string') {
        try {
          recipeData = JSON.parse(recipeData)
        } catch (error) {
          return {}
        }
      }

      return typeof recipeData === 'object' && recipeData !== null ? recipeData : {}
    },

    /**
     * Builds rating markup for recipe cards when rating data is valid.
     */
    getRecipeRatingHtml(item) {
      const recipeData = this.parseRecipekit(item?.recipekit)
      const numericRating = parseFloat(recipeData.recipe_rating) || 0
      const ratingCount = parseFloat(recipeData.rating_count) || 0

      if (ratingCount > 1 && numericRating > 0) {
        const displayRating = Math.min(numericRating, 5)
        return `<span>${Math.round(displayRating)}/5</span>`
      }

      return ''
    },

    /**
     * Returns localized serving size text for a recipe item.
     */
    getRecipeServingText(item) {
      const recipeData = this.parseRecipekit(item?.recipekit)
      const serving = recipeData.serving_size

      if (serving === undefined || serving === null || serving === '') {
        return ''
      }

      return `${serving}${Number(serving) === 1 ? ' Portion' : ' Portionen'}`
    },

    /**
     * Formats recipe duration, preferring ISO fields (PT1H30M) with legacy fallback.
     */
    getRecipeDurationText(item) {
      const recipeData = this.parseRecipekit(item?.recipekit)

      function parseIsoDurationToMinutes(isoDuration) {
        if (typeof isoDuration !== 'string') return null

        const match = isoDuration.match(/^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/i)
        if (!match) return null

        const hours = parseInt(match[1] || '0', 10)
        const minutes = parseInt(match[2] || '0', 10)
        const seconds = parseInt(match[3] || '0', 10)

        return hours * 60 + minutes + Math.floor(seconds / 60)
      }

      function parseLegacyTimeToMinutes(timeStr) {
        if (!timeStr || typeof timeStr !== 'string') return 0

        if (timeStr.indexOf(':') !== -1) {
          const colonParts = timeStr.split(':')
          if (colonParts.length === 2) {
            const hrs = parseInt(colonParts[0], 10)
            const mins = parseInt(colonParts[1], 10)
            return (isNaN(hrs) ? 0 : hrs * 60) + (isNaN(mins) ? 0 : mins)
          }
        }

        const parts = timeStr.split(' ')
        if (parts.length < 2) return 0

        const num = parseFloat(parts[0])
        const unit = parts[1].toLowerCase()
        if (isNaN(num)) return 0

        if (unit.indexOf('hour') !== -1 || unit.indexOf('stunde') !== -1) {
          return Math.round(num * 60)
        }
        if (unit.indexOf('min') !== -1) {
          return Math.round(num)
        }

        return 0
      }

      let totalMinutes = parseIsoDurationToMinutes(recipeData.iso_total_time)

      if (totalMinutes === null) {
        const isoPrepMinutes = parseIsoDurationToMinutes(recipeData.iso_prep_time)
        const isoCookMinutes = parseIsoDurationToMinutes(recipeData.iso_cook_time)

        if (isoPrepMinutes !== null || isoCookMinutes !== null) {
          totalMinutes = (isoPrepMinutes || 0) + (isoCookMinutes || 0)
        }
      }

      if (totalMinutes === null) {
        totalMinutes = parseLegacyTimeToMinutes(recipeData.prep_time) + parseLegacyTimeToMinutes(recipeData.cook_time)
      }

      const totalHours = Math.floor(totalMinutes / 60)
      const remainingMinutes = totalMinutes % 60

      let formatted = ''
      if (totalHours > 0) {
        formatted += totalHours + (totalHours === 1 ? ' Stunde' : ' Stunden')
      }
      if (remainingMinutes > 0) {
        if (formatted !== '') {
          formatted += ' '
        }
        formatted += remainingMinutes + ' Minuten'
      }

      return formatted || '0 Minuten'
    },

    filterProducts(products) {
      return products.filter((product) => !this.excludedHandles.includes(product.handle))
    },

    getProductPriceText(product, includeTaxNotice = false) {
      const variants = Array.isArray(product?.variants) ? product.variants : []
      const taxNotice = includeTaxNotice ? ' *' : ''
      const formLabel = product.id == 12043292016904 ? 'ab ' : '' // digitaler gutschein ausnahme -> 'ab' vor den preis stellen

      return `${formLabel}${variants[0].price.toFixed(2)} €${taxNotice}`   
    },

    toggleFacet(event, facet, category) {
      while (this.debounceTimer !== 0) {
        if (facetDistribution[type].tags[this.type === 'product' ? availableFacetCategories[this.type][category].label + facet : facet] == 0) {
          event.preventDefault()
          return
        }
      }
      if (!Alpine.store('meiliFilterWithCheckboxes').enabled) {
        event.preventDefault()
        if (event.target.classList.contains('filter-btn')) {
          event.target.classList.toggle('isSelected')
        } else {
          event.target.parentElement.classList.toggle('isSelected')
        }
      }
      const index = this.selectedFacets.indexOf(encodeURIComponent(facet))
      if (index > -1) {
        this.selectedFacets.splice(index, 1)
        const categoryIndex = this.selectedFacetCategories[category].indexOf(facet.split('_').at(-1))
        if (categoryIndex > -1) {
          this.selectedFacetCategories[category].splice(categoryIndex, 1)
        }
      } else {
        this.selectedFacets.push(encodeURIComponent(facet))
        this.selectedFacetCategories[category].push(facet.split('_').at(-1))
      }
      this.debounceTimer = 300
      this.search()
    },

    debounce_facet() {
      this.debounceTimer = 100
      setTimeout(() => {
        this.debounceTimer = 0
      }, 10)
    },

    toggleMobileFilter(event) {
      event?.preventDefault()
      event?.stopPropagation()
      this.filterPanelOpen = !this.filterPanelOpen
      this.filterType = 'all'
    },

    toggleChat(event) {
      event.preventDefault()
      this.type = 'chatbot'
    },

    closeMobileFilter(event) {
      event?.preventDefault()
      event?.stopPropagation()
      this.filterPanelOpen = false
      this.filterType = 'all'
    },

    changeFilter(event = null, filterType) {
      if (event != null) event.preventDefault()
      this.filterType = filterType
      if (window.innerWidth > 768 && !Alpine.store('meiliNewProductsVisible').enabled) {
        currentResultHeader =
          Alpine.store('meiliheader').type === 'product' ? document.querySelector('.result-header') : document.querySelector('.result-header.recipe')
        const filterChips = document.querySelector('.filterChipContainer')
        currentResultHeader.insertAdjacentElement('afterbegin', filterChips)
      }
    },

    viewAllResults(event) {
      if (event) event.preventDefault()
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=all`
    },

    viewAllProducts(event) {
      if (event) event.preventDefault()
      const meilisearchElement = document.querySelector('.meilisearch')
      this.open = false
      meilisearchElement.classList.remove('has-results')
      let facetsPart = ''
      let sortsPart = ''
      if (this.selectedFacets.length > 0) {
        facetsPart = `&facets=[${this.selectedFacets.join(',')}]`
      }
      if (this.sort) {
        sortsPart += `&sort=${this.sort}`
      }
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product${facetsPart}${sortsPart}`
    },

    viewAll(event) {
      if (event) event.preventDefault()
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=product`
    },

    viewAllPages(event) {
      if (event) event.preventDefault()
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=page`
    },

    viewAllArticles(event) {
      if (event) event.preventDefault()
      const meilisearchElement = document.querySelector('.meilisearch')
      this.open = false
      meilisearchElement.classList.remove('has-results')
      let facetsPart = ''
      let sortsPart = ''
      if (this.selectedFacets.length > 0) {
        facetsPart = `&facets=[${this.selectedFacets.join(',')}]`
      }
      if (this.sort) {
        sortsPart += `&sort=${this.sort}`
      }
      window.location.href = `/search?query=${encodeURIComponent(this.query)}&type=recipe${facetsPart}${sortsPart}`
    },

    goToPage(pageNumber) {
      this.page = pageNumber
      this.search(true)
    },

    nextPage() {
      if (this.type === 'product' && this.page < this.totalPages) {
        this.goToPage(this.page + 1)
      }
      if (this.type === 'recipe' && this.page < this.totalRecipePages) {
        this.goToPage(this.page + 1)
      }
    },

    previousPage() {
      if (this.type === 'product' && this.page > 1) {
        this.goToPage(this.page - 1)
      }
      if (this.type === 'recipe' && this.page > 1) {
        this.goToPage(this.page - 1)
      }
    },

    resetFacets() {
      this.selectedFacets = []
      ;(this.selectedFacetCategories = {
        sort: ['Relevanz'],
        geeignet_zum: [],
        passt_zu: [],
        ernaehrung: [],
        landestypisch: [],
        ernaehrungsweise: [],
        art: [],
        herkunft: [],
        zubereitungsweise: [],
      }),
        this.search()
      if (Alpine.store('meiliFilterWithCheckboxes').enabled) {
        let filterCheckboxes = document.querySelectorAll('.filter-checkbox')
        filterCheckboxes.forEach((checkbox) => {
          checkbox.checked = false
        })
      } else {
        let filterButtons = document.querySelectorAll('.filter-btn')
        filterButtons.forEach((button) => button.classList.remove('isSelected'))
      }
    },

    resetSorting() {
      this.selectedFacetCategories.sort = ['Relevanz']
      const sortRadios = document.getElementsByName('sortFilterContainer')
      sortRadios.forEach((element) => {
        const selection = element.querySelectorAll('input[type="radio"]')
        selection.forEach((radio) => {
          if (radio.id === 'Relevanz') {
            radio.setAttribute('checked', 'true')
            radio.checked = true
          } else {
            radio.setAttribute('checked', 'false')
            radio.removeAttribute('checked')
            radio.checked = false
          }
        })
      })
    },

    changeTypeBubble(event, newType) {
      event.preventDefault()
      if (newType === 'recipe') {
        this.sort = ''
      } else {
        this.sort = '[monthly_sales:desc]'
      }
      this.resetSorting()
      this.type = newType
      this.changeFilter(null, 'all')
      this.resetFacets()
      this.search()
    },

    handleResize() {
      this.width = window.innerWidth

      if (window.location.pathname === '/search') return

      const meilisearchElement = document.querySelector('.meilisearch')

      if (!meilisearchElement?.classList?.contains('isOpen')) {
        meilisearchElement.classList.remove('has-results')
      }
    },

    logCTR(id) {
      // fetch(`http://localhost:3000/tracking/ctr?search_query=${this.query}&id=${id}`, {
      //   method: 'GET',
      //   headers: {
      //     'Authorization': 'Bearer supersecret'
      //   },
      //   keepalive: true
      // },
      // )
    },

    initialize() {
      const params = new URLSearchParams(window.location.search)
      this.query = params.get('query') || ''
      this.type = params.get('type') || 'product'
      const facetsParam = params.get('facets')
      const sortParam = params.get('sort')
      if (facetsParam) {
        let stripped = facetsParam.replace(/^\[|\]$/g, '')
        this.selectedFacets = stripped ? stripped.split(',') : []
      }
      if (sortParam) {
        this.sort = sortParam
      }
      this.search(true)
    },

    add_to_cart(event, variants_id) {
      event.preventDefault()
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({items: [{id: variants_id, quantity: 1}]}),
      })
        .then((response) => {
          if (!response.ok) {
            console.error('Error:', error)
          } else {
            document.querySelector('.cartiicon.Icon-Wrapper--clickable').click()
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
              })
            )
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    },
  }
}

document.addEventListener('alpine:init', () => {
  Alpine.store('meilimeta', {enabled: 'true' === 'true'})

  // 2026 AB Test winners
  // Alpine.store('meilimetaNew', { enabled: true });
  Alpine.store('meiliNewProductsVisible', {enabled: true})
  // Alpine.store('meiliOldFilter', { enabled: true });
  Alpine.store('meiliFilterWithCheckboxes', {enabled: false})

  if (window.location.pathname === '/search') {
    Alpine.store('meilibody', searchComponent())
    Alpine.store('meilibody').initialize()
  }
  Alpine.store('meiliheader', searchComponent())
  Alpine.store('meiliblog', searchComponent())
  Alpine.store('meiliblog').type = 'recipe'
})

function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

const meilisearchElement = document.querySelector('.meilisearch')

async function checkMeilisearchHealth() {
  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 2000)
    const response = await fetch('https://suche.ankerkraut.de/health', {signal: controller.signal})
    clearTimeout(timeoutId)
    if (!response.ok) {
      throw new Error('Meilisearch health check failed')
    }
    const healthStatus = await response.text()
    if (healthStatus !== 'OK') {
      throw new Error('Meilisearch is not available')
    }
  } catch (error) {
    console.error('Meilisearch health check failed:', error)
    Alpine.store('meilimeta', {enabled: false})
  }
}
checkMeilisearchHealth()
